import { TopPage } from "@/components/elements/TopPage";
import { IndustryForm } from "@/features/learning-content/components/IndustryForm";
import { Stack, Typography } from "@mui/material";
import { FC, useRef } from "react";
import { styled } from "@mui/system";

type TIndustryCreatePageProps = {};

export const IndustryCreatePage: FC<TIndustryCreatePageProps> = () => {
  const formRef = useRef<{ submit: () => void }>(null);

  return (
    <PartnerWrapper gap={4}>
      <TopPage
        title={
          <Typography variant="head32Bold" display="flex" alignItems="center" gap={2}>
            新規分野の登録
          </Typography>
        }
        description={
          <Typography variant="body14">
            irohana studyに新しい分野を追加します。必要情報を入力してください。保存後に試験情報と科目別コンテンツも登録してください。
          </Typography>
        }
        enablePageBack={false}
      />
      <IndustryForm ref={formRef} />
    </PartnerWrapper>
  );
};

const PartnerWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
  margin-top: 8px;
`;
